module.exports = __webpack_public_path__ + "static/media/left-bg.6f4cb2d1.png";